// src/utils/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCsiL_me9OFIlos-aLiwU4x2smKk4dyC7A",
  authDomain: "mpp-m3c.firebaseapp.com",
  projectId: "mpp-m3c",
  storageBucket: "mpp-m3c.firebasestorage.app",
  messagingSenderId: "844170504475",
  appId: "1:844170504475:web:a8b9ad782d02235bb2cbbe",
  measurementId: "G-YLWL2WF98P"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);